import React, { useEffect, useRef, useState } from 'react';
import { 
  RiDeleteBin6Line, 
  RiEdit2Line, 
  RiAddLine,
  RiSearchLine,
  RiArrowUpLine,
  RiArrowDownLine,
  RiMore2Line,
  RiEyeLine,
  RiRefreshLine
} from 'react-icons/ri';
import { 
  FiSearch, 
  FiPlus, 
  FiTrash2, 
  FiEdit2, 
  FiToggleLeft, 
  FiToggleRight,
  FiCheckCircle,
  FiXCircle,
  FiTag,
  FiPercent,
  FiUsers,
  FiClock,
  FiRefreshCw,
  FiArrowUp,
  FiArrowDown,
  FiMoreVertical
} from "react-icons/fi";
import { MdOutlineDelete, MdOutlineEdit, MdOutlineAdd, MdOutlineSearch } from "react-icons/md";
import ReactPaginate from 'react-paginate';

const ReferalTable = ({
  TableName,
  TableHeader,
  TableData,
  showMenu,
  deleteAction,
  handleToggle,
  handleCreateModal,
  keyword,
  setKeyword,
  pageNo,
  setpageNo,
  size,
  setSize,
  total,
  handlePageClick
}) => {
  const ContentActionRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ContentActionRef.current && !ContentActionRef.current.contains(event.target)) {
        showMenu(null);
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  // Status badge component
  const StatusBadge = ({ isDisable }) => {
    if (isDisable) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-rose-700 bg-rose-50 border border-rose-200 rounded-full">
          <FiXCircle className="w-3.5 h-3.5 text-rose-500" />
          Inactive
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
        <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
        Active
      </span>
    );
  };

  return (
    <div className="w-full">
      <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
              <FiTag className="w-4 h-4 text-[#715EFE]" />
            </div>
            <div>
              <h2 className="text-base font-semibold text-gray-800">{TableName}</h2>
              <p className="text-xs text-gray-400 hidden sm:block">
                {total || 0} referral codes
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <div className="relative flex-1 sm:min-w-[200px]">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search referral codes..."
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
              />
            </div>
            <button
              onClick={() => handleCreateModal('REFERAL')}
              className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-[#855DF6] to-[#715EFE] rounded-lg hover:shadow-lg hover:shadow-[#715EFE]/25 transition-all duration-200 whitespace-nowrap"
            >
              <FiPlus className="w-4 h-4" />
              <span>New Referral Code</span>
            </button>
          </div>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50/80 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                {TableHeader.map((heading, index) => {
                  const headerIcons = {
                    '#': null,
                    'Referral Code': FiTag,
                    'Status': FiToggleLeft,
                    'Associated Reward': FiPercent,
                    'Action': null
                  };
                  const Icon = headerIcons[heading];
                  return (
                    <th key={index} className="px-3 md:px-4 py-3 text-left whitespace-nowrap">
                      <div className="flex items-center gap-1.5">
                        {Icon && <Icon className="w-3.5 h-3.5 text-gray-400" />}
                        <span>{heading}</span>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {TableData && TableData.length > 0 ? (
                TableData.map((ele, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors duration-150 group">
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-medium text-gray-400">
                        {(pageNo - 1) * size + index + 1}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                          <FiTag className="w-3.5 h-3.5 text-[#715EFE]" />
                        </div>
                        <span className="text-sm font-semibold text-gray-800 font-mono">
                          {ele.ReferralCode || '-'}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <StatusBadge isDisable={ele?.isDisable} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center">
                          <FiPercent className="w-3.5 h-3.5 text-emerald-600" />
                        </div>
                        <span className="text-sm font-semibold text-emerald-600">
                          {ele?.percentDiscount}% Discount
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-1">
                        <button
                          className="p-1.5 text-rose-400 hover:text-rose-600 hover:bg-rose-50 rounded-lg transition-all duration-200"
                          onClick={() => deleteAction(ele)}
                          title="Delete referral code"
                        >
                          <FiTrash2 className="w-4 h-4" />
                        </button>
                        <button
                          className={`p-1.5 rounded-lg transition-all duration-200 ${
                            ele?.isDisable
                              ? 'text-emerald-400 hover:text-emerald-600 hover:bg-emerald-50'
                              : 'text-amber-400 hover:text-amber-600 hover:bg-amber-50'
                          }`}
                          onClick={() => handleToggle(ele)}
                          title={ele?.isDisable ? 'Activate' : 'Deactivate'}
                        >
                          {ele?.isDisable ? (
                            <FiToggleRight className="w-4 h-4" />
                          ) : (
                            <FiToggleLeft className="w-4 h-4" />
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={TableHeader.length} className="px-4 py-12 text-center">
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4 bg-gray-50 rounded-full">
                        <FiTag className="w-10 h-10 text-gray-300" />
                      </div>
                      <p className="text-sm font-medium text-gray-500">No referral codes found</p>
                      <p className="text-xs text-gray-400">Create your first referral code</p>
                      <button
                        onClick={() => handleCreateModal('REFERAL')}
                        className="mt-2 flex items-center gap-2 px-4 py-2 text-sm font-medium text-[#715EFE] border border-[#715EFE] rounded-lg hover:bg-[#715EFE] hover:text-white transition-all duration-200"
                      >
                        <FiPlus className="w-4 h-4" />
                        Create Referral Code
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile View for Small Screens */}
        <div className="md:hidden divide-y divide-gray-100">
          {TableData && TableData.length > 0 ? (
            TableData.map((ele, index) => (
              <div key={index} className="p-4 hover:bg-gray-50/70 transition-colors duration-150">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-medium text-gray-400">
                      #{(pageNo - 1) * size + index + 1}
                    </span>
                    <StatusBadge isDisable={ele?.isDisable} />
                  </div>
                  <div className="flex items-center gap-1">
                    <button
                      className="p-1.5 text-rose-400 hover:text-rose-600 hover:bg-rose-50 rounded-lg transition-all duration-200"
                      onClick={() => deleteAction(ele)}
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>
                    <button
                      className={`p-1.5 rounded-lg transition-all duration-200 ${
                        ele?.isDisable
                          ? 'text-emerald-400 hover:text-emerald-600 hover:bg-emerald-50'
                          : 'text-amber-400 hover:text-amber-600 hover:bg-amber-50'
                      }`}
                      onClick={() => handleToggle(ele)}
                    >
                      {ele?.isDisable ? (
                        <FiToggleRight className="w-4 h-4" />
                      ) : (
                        <FiToggleLeft className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Code</span>
                    <span className="text-sm font-semibold text-gray-800 font-mono">
                      {ele.ReferralCode || '-'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Discount</span>
                    <span className="text-sm font-semibold text-emerald-600">
                      {ele?.percentDiscount}% Discount
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="p-8 text-center">
              <div className="flex flex-col items-center gap-2">
                <FiTag className="w-10 h-10 text-gray-300" />
                <p className="text-sm text-gray-500">No referral codes found</p>
              </div>
            </div>
          )}
        </div>

        {/* Pagination */}
        {total > size && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-gray-100 bg-gray-50/50">
            <div className="text-sm text-gray-500">
              Showing {((pageNo - 1) * size) + 1} to {Math.min(pageNo * size, total)} of {total} entries
            </div>
            <ReactPaginate
              previousLabel={'Prev'}
              nextLabel={'Next'}
              breakLabel={'...'}
              breakClassName={'px-2 text-gray-400'}
              pageCount={Math.ceil(total / size)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={'flex items-center gap-1'}
              pageClassName={'px-2'}
              pageLinkClassName={'px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200'}
              previousClassName={'px-2'}
              previousLinkClassName={'px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200'}
              nextClassName={'px-2'}
              nextLinkClassName={'px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200'}
              activeClassName={'bg-[#715EFE] text-white rounded-md'}
              activeLinkClassName={'bg-[#715EFE] text-white px-3 py-1 rounded-md'}
              disabledClassName={'opacity-50 cursor-not-allowed'}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferalTable;